<div class="card card-outline card-primary">
    <div class="card-header text-center">
        <h1><b>Simple</b>Laundry</h1>
    </div>
    <div class="card-body">
        <p class="login-box-msg">Iniciar sesión</p>

        <form [formGroup]="loginForm">
            <div class="input-group mb-3">
                <input
                    formControlName="username"
                    type="text"
                    class="form-control"
                    placeholder="Usuario"
                />
                <div class="input-group-append">
                    <div class="input-group-text">
                        <span class="fas fa-user"></span>
                    </div>
                </div>
            </div>
            <div class="input-group mb-3">
                <input
                    formControlName="password"
                    type="password"
                    class="form-control"
                    placeholder="Contraseña"
                    (keyup.enter)="loginByAuth()"
                />
                <div class="input-group-append">
                    <div class="input-group-text">
                        <span class="fas fa-lock"></span>
                    </div>
                </div>
            </div>
            <div class="row">
               <!--  <div class="col-7">
                    <div class="icheck-primary">
                        <input type="checkbox" id="remember" />
                        <label for="remember"> Remember Me </label>
                    </div>
                </div> -->
                <!-- /.col -->
                <div class="col-12">
                    <pf-button
                        [type]="'button'"
                        [block]="true"
                        [loading]="isAuthLoading"
                        [disabled]="isFacebookLoading || isGoogleLoading"
                        (click)="loginByAuth()"
                    >
                        Iniciar Sesion
                    </pf-button>
                </div>
                <!-- /.col -->
            </div>
        </form>

<!--         <div class="social-auth-links text-center mb-3">
            <pf-button
                class="mb-2"
                [block]="true"
                [loading]="isFacebookLoading"
                [disabled]="isAuthLoading || isGoogleLoading"
                (click)="loginByFacebook()"
            >
                <i class="fab fa-facebook mr-2"></i>
                Sign in using Facebook
            </pf-button>
            <pf-button
                [block]="true"
                [loading]="isGoogleLoading"
                [disabled]="isAuthLoading || isFacebookLoading"
                theme="danger"
                (click)="loginByGoogle()"
            >
                <i class="fab fa-google mr-2"></i>
                Sign in using Google+
            </pf-button>
        </div>

        <p class="mb-1">
            <a [routerLink]="['/forgot-password']">I forgot my password</a>
        </p>
        <p class="mb-0">
            <a [routerLink]="['/register']" class="text-center">
                Register a new membership
            </a>
        </p> -->
    </div>
    <!-- /.login-card-body -->
</div>
